import { CheckboxGroup, CheckboxGroupProps } from '@infotech-soe/erp-ui-kit';
import React from 'react';

import {
  CheckboxGroupFormControlViewModel,
  SetCheckboxGroupFormControlViewModel,
} from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';

interface Props
  extends
    Pick<TFormControlConnectorProps, 'areHintsShown'>,
    Pick<CheckboxGroupProps, 'onChange' | 'onChanged' | 'onSubmit'> {
  control:
    CheckboxGroupFormControlViewModel | SetCheckboxGroupFormControlViewModel;
}

const FormCheckGroupControl: React.FC<Props> = ({
  areHintsShown,
  control,
  onChange,
  onChanged,
  onSubmit,
}) => (
  <CheckboxGroup
    value={control.value}
    options={control.options}
    disabled={control.disabled}
    filterMode={control.filterMode}
    {...(areHintsShown && { hint: control.hint })}
    label={control.noLabel ? '' : control.label}
    onChange={onChange}
    onChanged={onChanged}
    onSubmit={onSubmit}
    columns={control.items}
  />
);

export default FormCheckGroupControl;
